<template>
  <div class="error">
    <slot class="title" name="title" />
    <slot class="subtitle" name="subtitle" />
    <slot class="message" name="message" />
    <brand-button class="button" @click="onClick">
      <slot class="buttonLabel" name="buttonLabel" />
    </brand-button>
  </div>
</template>

<script>
export default {
  name: 'error',
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="sass" scoped>
.error
  text-align: center
  min-height: calc(100vh - 315px)

.title
  margin-top: baseunit(7.2)

.subtitle
  font-weight: bold
  margin-top: $glass-spacing-2
  color: $font-color-dark
  white-space: pre-line

.message
  margin-top: $glass-spacing-2
  white-space: pre-line
  .phoneNumber
    text-decoration: underline

.button
  margin-top: $glass-spacing-6
  margin-bottom: $glass-spacing-6
</style>
